import cloneDeep from 'lodash/cloneDeep';
import lodashGet from 'lodash/get';
import lodashOrderBy from 'lodash/orderBy';
import { pubRegexp, util } from '@/api/util/index';
import { personalRegexp } from '@/api/util/index';
import { locationHelper } from '@/api/util/location_helper';
import { api as masterApi } from '@/api/api';
import { apis } from '@/config';
import { readOrgContactsByOrgIds, writeOrgContactsToLoki, writeContactsToLoki, deleteOrgContactsByOrgId, readOrgInfoByOrgIds, } from './contact_sync_enterprise_loki';
import { contactSearchDbName, orgTable, lxInfoTable } from './util/const';
export class ContactImplEnterprise {
    constructor(ctx) {
        this._orgCache = new Map();
        this._orgCacheBuilding = new Map();
        this.ctx = ctx;
    }
    clearOrgCache(account) {
        this._orgCache.delete(account);
        console.log('[OrgCache] cleared for account:', account);
    }
    inferOrgType(orgId) {
        if (orgId.startsWith('personal_org_')) {
            return 'personal';
        }
        if (orgId.startsWith('team_')) {
            return 'team';
        }
        return 'enterprise';
    }
    getLokiApi() {
        return masterApi.requireLogicalApi(apis.dbMemoryApiImpl);
    }
    async doGetContactReadySync(_source) {
        return false;
    }
    doGetLocalContactReady() {
        if (locationHelper.isFrontPage()) {
            this.ctx.contactDB.detectCoreEnterpriseHasData({}).then(status => this.ctx.contactSync.setContactReady(status !== 'none'));
        }
        return this.ctx.contactSync.getContactReady();
    }
    doGetContactLastUpdateTime(_account) {
        return this.ctx.contactDB.getContactLastUpdateTime(_account);
    }
    async doGetOrgContactListByOrgId(_idList, _account = this.ctx.contactUtil.getCurrentAccount()) {
        console.warn('[contact] doGetOrgContactListByOrgId is deprecated');
        return [];
    }
    getContactSyncTimes() {
        return this.ctx.contactDB.contactSyncTimes;
    }
    getContactSyncState(type = 'contact') {
        if (type === 'contact') {
            return false;
        }
        if (type === 'customer') {
            return this.ctx.contactSync.isSyncCustomer;
        }
        return this.ctx.contactSync.isSyncColleague;
    }
    async doGetContactByEmails(_emails = [], type) {
        const rawContacts = _emails.map(({ mail, contactName = '' }) => this.ctx.mailApi.buildRawContactItem({
            item: mail,
            email: mail,
            type,
            name: contactName,
        }));
        const emails = _emails.map(({ mail }) => mail);
        try {
            const contactsEntity = await this.ctx.facade.doGetContactByItem({
                type: 'EMAIL',
                value: emails,
            });
            const dbContacts = contactsEntity.reduce((acc, item) => {
                const { avatar, contactName } = item.contact;
                const _index = emails.indexOf(item.contact.accountName);
                if (_index !== -1) {
                    const _contact = acc[_index].contact;
                    acc[_index] = Object.assign(Object.assign({}, acc[_index]), { contact: Object.assign(Object.assign({}, _contact), { contact: Object.assign(Object.assign({}, _contact.contact), { contactName,
                                avatar }) }), inContactBook: true });
                }
                return acc;
            }, rawContacts);
            return dbContacts.length > 0 ? dbContacts : rawContacts;
        }
        catch (error) {
            console.warn(error);
            return rawContacts;
        }
    }
    async _buildOrgData(_account) {
        const lokiApi = this.getLokiApi();
        const lokiOrgList = (await lokiApi.getByRangeCondition({
            dbName: contactSearchDbName,
            tableName: orgTable,
            _dbAccount: _account,
            adCondition: { field: 'type', type: 'noneOf', args: [[1, 2, 2000]] },
        }));
        if (!(lokiOrgList === null || lokiOrgList === void 0 ? void 0 : lokiOrgList.length)) {
            return { lokiOrgList: [], orgAllMap: {}, orgModel2: {} };
        }
        const orgAllMap = util.listToMap(lokiOrgList, 'id');
        const allOrgIdMap = new Map();
        lokiOrgList.forEach(item => {
            var _a;
            const parentMap = (_a = allOrgIdMap.get(item.parent)) !== null && _a !== void 0 ? _a : new Map();
            parentMap.set(item.id, item);
            allOrgIdMap.set(item.parent, parentMap);
        });
        const getAllDescendants = (id) => {
            const childMap = allOrgIdMap.get(id);
            if (!(childMap === null || childMap === void 0 ? void 0 : childMap.size))
                return [];
            const result = [];
            const visited = new Set([id]);
            const stack = [...childMap.values()].reverse();
            while (stack.length) {
                const model = stack.pop();
                if (!model) {
                    continue;
                }
                if (visited.has(model.id)) {
                    continue;
                }
                visited.add(model.id);
                result.push(model);
                const nextChildMap = allOrgIdMap.get(model.id);
                if (!(nextChildMap === null || nextChildMap === void 0 ? void 0 : nextChildMap.size)) {
                    continue;
                }
                const nextChildren = [...nextChildMap.values()];
                for (let i = nextChildren.length - 1; i >= 0; i -= 1) {
                    const child = nextChildren[i];
                    if (!visited.has(child.id)) {
                        stack.push(child);
                    }
                }
            }
            return result;
        };
        const orgModel2 = {};
        allOrgIdMap.forEach((childMap, parentId) => {
            const children = lodashOrderBy([...childMap.values()], ['orgRank', 'orgName'], ['desc', 'asc']);
            orgModel2[parentId] = { children, orgList: getAllDescendants(parentId) };
        });
        return { lokiOrgList, orgAllMap, orgModel2 };
    }
    async _getOrCacheOrgData(_account) {
        const cached = this._orgCache.get(_account);
        if (cached)
            return cached;
        const inFlight = this._orgCacheBuilding.get(_account);
        if (inFlight)
            return inFlight;
        const promise = this._buildOrgData(_account);
        this._orgCacheBuilding.set(_account, promise);
        try {
            const entry = await promise;
            this._orgCache.set(_account, entry);
            return entry;
        }
        finally {
            this._orgCacheBuilding.delete(_account);
        }
    }
    async doGetContactOrg(option) {
        const { orgId, level, _account = this.ctx.contactUtil.getCurrentAccount() } = option !== null && option !== void 0 ? option : {};
        try {
            const { lokiOrgList, orgAllMap } = await this._getOrCacheOrgData(_account);
            if (!lokiOrgList.length) {
                console.error('[contact] doGetContactOrg orgTable is null');
                return { org: {}, children: [], orgList: [] };
            }
            return this.ctx.contactTrans.transformOrgData({ orgId, level, orgAllList: lokiOrgList, orgAllMap });
        }
        catch (error) {
            console.error('[contact] doGetContactOrg error', error);
            return Promise.reject(error);
        }
    }
    async doGetContactOrgMap(params) {
        var _a;
        const _account = (_a = params === null || params === void 0 ? void 0 : params._account) !== null && _a !== void 0 ? _a : this.ctx.contactUtil.getCurrentAccount();
        const { orgModel2 } = await this._getOrCacheOrgData(_account);
        return orgModel2;
    }
    doGet(orgId, level) {
        return this.doGetContactOrg({ orgId, level });
    }
    async doGetContactByQiyeAccountId(query) {
        const list = await this.ctx.contactServer.getContactByQiyeAccountId(query);
        return list;
    }
    async fetchAndCacheContactDetail(params) {
        var _a, _b;
        const { id, _account, email } = params;
        if (!id)
            return { models: [], detailRestricted: false };
        let enterpriseId = (_a = this.ctx.systemApi.getCurrentCompanyId(_account)) !== null && _a !== void 0 ? _a : -1;
        try {
            const lokiHits = await this.ctx.contactDB.getContactsInMemoryMode({ fields: [id], type: 'contactId', _account });
            const lokiEnterpriseId = parseInt(lodashGet(lokiHits, '[0].enterpriseId', ''), 10);
            if (!isNaN(lokiEnterpriseId) && lokiEnterpriseId > 0) {
                enterpriseId = lokiEnterpriseId;
            }
        }
        catch (_c) {
        }
        const domain = this.ctx.contactServer.resolveDomain(enterpriseId, _account);
        const lastUpdateTime = Date.now();
        const isPub = pubRegexp.test(id);
        const [newApiResult, oldContactModels] = await Promise.all([
            isPub && !email
                ? Promise.resolve({ contacts: [], contactItems: [] })
                : this.ctx.contactServer.getEnterpriseContactDetail({
                    queryType: isPub ? 'email' : 'accountId',
                    queryValues: isPub ? email : id,
                    enterpriseId,
                    domain,
                    lastUpdateTime,
                    _account,
                }),
            this.ctx.contactServer.getContactByQiyeAccountId({ idList: [id], domain, _account }),
        ]);
        const oldApiContactMap = new Map();
        (oldContactModels || []).forEach((m) => {
            var _a;
            if ((_a = m === null || m === void 0 ? void 0 : m.contact) === null || _a === void 0 ? void 0 : _a.id) {
                oldApiContactMap.set(m.contact.id, m);
            }
        });
        const contacts = newApiResult.contacts;
        const contactItems = newApiResult.contactItems;
        contacts.forEach((ec) => {
            const oldModel = oldApiContactMap.get(ec.id);
            if (oldModel === null || oldModel === void 0 ? void 0 : oldModel.contact) {
                ec.avatar = oldModel.contact.avatar || ec.avatar;
                ec.avatarPendant = oldModel.contact.avatarPendant || ec.avatarPendant;
            }
            if (oldModel === null || oldModel === void 0 ? void 0 : oldModel.contactInfo) {
                oldModel.contactInfo.forEach((ci) => {
                    if (ci.contactItemType === 'yunxin') {
                        contactItems.push(ci);
                    }
                });
            }
        });
        if (!contacts.length) {
            return { models: oldContactModels || [], detailRestricted: true };
        }
        const lxInfoRows = contacts.map((ec) => {
            const oldModel = oldApiContactMap.get(ec.id);
            const yunxinItem = ((oldModel === null || oldModel === void 0 ? void 0 : oldModel.contactInfo) || []).find((ci) => ci.contactItemType === 'yunxin');
            return {
                contactId: ec.id,
                avatar: ec.avatar || '',
                avatarPendant: ec.avatarPendant || '',
                yxid: (yunxinItem === null || yunxinItem === void 0 ? void 0 : yunxinItem.contactItemVal) || '',
                yxToken: (yunxinItem === null || yunxinItem === void 0 ? void 0 : yunxinItem.contactItemRefer) || '',
            };
        });
        try {
            await this.ctx.contactDB.contactDetailInto(this.getLokiApi(), contacts, contactItems, lxInfoRows, _account);
            (_b = this.ctx.contactSync.tracker) === null || _b === void 0 ? void 0 : _b.recordIncrementalOp({
                api: 'getEnterpriseContactDetail',
                timestamp: Date.now(),
                returnCount: contacts.length,
                targetTables: ['contact', 'contactItem', 'lx_info'],
                dexieWritten: contacts.length,
                lokiWritten: contacts.length,
                params: `${isPub ? 'email' : 'accountId'}=${isPub ? email : id}`,
            });
        }
        catch (e) {
            console.error('[contact_impl] fetchAndCacheContactDetail write error', e);
        }
        const contactIdMap = util.listToMap(contacts, 'id');
        const contactInfoIdMap = util.listToMapValueList(contactItems, 'contactId');
        return {
            models: this.ctx.contactTrans.transformContactModel({
                orderByIdList: contacts.map((c) => c.id),
                contactIdMap,
                contactInfoIdMap,
            }),
            detailRestricted: false,
        };
    }
    async fetchContactBase(params) {
        var _a, _b, _c;
        const { queryType, queryValues, _account, persist = false } = params;
        if (!queryValues.length)
            return [];
        const enterpriseId = (_a = this.ctx.systemApi.getCurrentCompanyId(_account)) !== null && _a !== void 0 ? _a : -1;
        const mainDomain = ((_b = this.ctx.systemApi.getCurrentUser(_account)) === null || _b === void 0 ? void 0 : _b.domain) || '';
        const lastUpdateTime = Date.now();
        const mainResult = await this.ctx.contactServer.getEnterpriseContactBase({
            queryType,
            queryValues,
            enterpriseId,
            domain: mainDomain,
            lastUpdateTime,
            _account,
        });
        let { contacts, contactItems } = mainResult;
        if (!contacts.length) {
            const otherDomains = this.ctx.contactServer.getAllDomains(_account).filter(d => d !== mainDomain);
            if (otherDomains.length) {
                const results = await Promise.all(otherDomains.map(d => this.ctx.contactServer
                    .getEnterpriseContactBase({
                    queryType,
                    queryValues,
                    enterpriseId,
                    domain: d,
                    lastUpdateTime,
                    _account,
                })
                    .catch(() => ({ contacts: [], contactItems: [] }))));
                for (const r of results) {
                    if (r.contacts.length) {
                        contacts = r.contacts;
                        contactItems = r.contactItems;
                        break;
                    }
                }
            }
        }
        if (!contacts.length)
            return [];
        if (persist) {
            try {
                await this.ctx.contactDB.searchResultInto(this.getLokiApi(), contacts, contactItems, _account);
                (_c = this.ctx.contactSync.tracker) === null || _c === void 0 ? void 0 : _c.recordIncrementalOp({
                    api: 'getEnterpriseContactBase',
                    timestamp: Date.now(),
                    returnCount: contacts.length,
                    targetTables: ['contact', 'contactItem'],
                    dexieWritten: contacts.length,
                    lokiWritten: contacts.length,
                    params: `${queryType}=[${queryValues.length}条]`,
                });
            }
            catch (e) {
                console.error('[contact_impl] fetchContactBase write error', e);
            }
        }
        const contactIdMap = util.listToMap(contacts, 'id');
        const contactInfoIdMap = util.listToMapValueList(contactItems, 'contactId');
        return this.ctx.contactTrans.transformContactModel({
            orderByIdList: contacts.map((c) => c.id),
            contactIdMap,
            contactInfoIdMap,
        });
    }
    assembleContactModelsFromMemory(memoryModels, _account, yunxinIdMap) {
        return memoryModels.map(item => {
            const yunxinId = yunxinIdMap === null || yunxinIdMap === void 0 ? void 0 : yunxinIdMap.get(item.id);
            const model = this.ctx.contactDB.transformMemoryModel2StandardModel(item, yunxinId ? { yunxinId } : undefined);
            model._account = _account;
            return model;
        });
    }
    async doGetContactById(id, _account = this.ctx.contactUtil.getCurrentAccount()) {
        const _idList = util.singleToList(id).filter(Boolean);
        if (!_idList.length) {
            return [];
        }
        let lokiHits = [];
        const missedIds = [];
        try {
            const lokiResults = await this.ctx.contactDB.getContactsInMemoryMode({
                fields: _idList,
                type: 'contactId',
                _account,
            });
            const hitIdSet = new Set(lokiResults.map(r => r.id));
            lokiHits = this.assembleContactModelsFromMemory(lokiResults, _account);
            _idList.forEach(id => {
                if (!hitIdSet.has(id)) {
                    missedIds.push(id);
                }
            });
        }
        catch (e) {
            console.warn('[contact_impl] doGetContactById loki query error, fallback to server', e);
            missedIds.push(..._idList);
        }
        if (!missedIds.length) {
            return lokiHits;
        }
        const enterpriseIds = missedIds.filter(id => !personalRegexp.test(id));
        let serverModels = [];
        if (enterpriseIds.length) {
            serverModels = await this.fetchContactBase({
                queryType: 'accountId',
                queryValues: enterpriseIds,
                _account,
            });
        }
        return [...lokiHits, ...serverModels];
    }
    doGetFullContactByIdWithCallback(options) {
        const { id, email, _account = this.ctx.contactUtil.getCurrentAccount(), onData } = options;
        if (!id) {
            return;
        }
        const isEnterprise = !personalRegexp.test(id);
        this.ctx.contactDB
            .getContactsInMemoryMode({
            fields: [id],
            type: 'contactId',
            _account,
        })
            .then(lokiResults => {
            const lokiHits = this.assembleContactModelsFromMemory(lokiResults, _account);
            if (lokiHits.length > 0) {
                onData(lokiHits);
            }
            if (!isEnterprise) {
                return;
            }
            this.fetchAndCacheContactDetail({ id, _account, email }).then(({ models, detailRestricted }) => {
                if (models.length > 0) {
                    onData(models, { detailRestricted });
                }
            });
        })
            .catch(() => {
            if (!isEnterprise) {
                return;
            }
            this.fetchAndCacheContactDetail({ id, _account, email }).then(({ models, detailRestricted }) => {
                if (models.length > 0) {
                    onData(models, { detailRestricted });
                }
            });
        });
    }
    async doGetOrgList(option = {}) {
        var _a;
        try {
            let orgIdList;
            let typeList;
            let originIdList;
            if (option.idList) {
                orgIdList = util.singleToList(option.idList);
            }
            if (option.typeList) {
                typeList = util.singleToList(option.typeList);
            }
            if (option.originIdList) {
                originIdList = util.singleToList(option.originIdList);
            }
            const orgList = await this.ctx.contactDB.getOrgList({
                idList: orgIdList,
                typeList,
                originIdList,
                showDisable: option.showDisable || false,
                _account: option._account || ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '',
            });
            return orgList;
        }
        catch (err) {
            console.error('[contact] doGetOrgList error', err);
            return Promise.reject(err);
        }
    }
    async doGetTeamList(list) {
        try {
            const teamList = await this.ctx.contactDB.getTeamListById(list);
            return teamList;
        }
        catch (err) {
            console.error('[contact] doGetTeamList error', err);
            return Promise.reject(err);
        }
    }
    async doGetServerContactByOrgIds(orgIdList, _account = this.ctx.contactUtil.getCurrentAccount()) {
        const { orgMap } = await this.ctx.contactServer.doGetContactByOrgId({ orgId: orgIdList, _account });
        return orgMap;
    }
    _isPersonalOrgId(orgId) {
        const { PERSON_ALL, PERSON_NO_GROUP } = this.ctx.contactUtil.StaticNodeKey;
        return !orgId || orgId === PERSON_ALL || orgId === PERSON_NO_GROUP || orgId.startsWith('personal_org_');
    }
    async _resolvePersonalOrgIds(personalOrgIds, _account) {
        const result = new Map();
        if (!personalOrgIds.length)
            return result;
        for (const orgId of personalOrgIds) {
            const effectiveOrgId = orgId || this.ctx.contactUtil.StaticNodeKey.PERSON_ALL;
            try {
                const memoryModels = await this.ctx.contactDB.getPersonalContactsFromMemory(effectiveOrgId, _account);
                const models = this.assembleContactModelsFromMemory(memoryModels, _account);
                result.set(orgId, lodashOrderBy(models, ['contact.contactLabel', 'contact.contactPYName', 'contact.contactName'], ['asc', 'asc', 'asc']));
            }
            catch (e) {
                console.warn(`[contact_impl] _resolvePersonalOrgIds error for orgId=${orgId}`, e);
                result.set(orgId, []);
            }
        }
        return result;
    }
    async _readLokiOrgContacts(enterpriseOrgIds, lokiApi, _account) {
        if (!enterpriseOrgIds.length)
            return new Map();
        return readOrgContactsByOrgIds(lokiApi, enterpriseOrgIds, _account);
    }
    _classifyMissingEnterpriseOrgIds(enterpriseOrgIds, lokiOrgContactsMap) {
        return enterpriseOrgIds.filter(orgId => {
            const rows = lokiOrgContactsMap.get(orgId);
            if (rows && rows.length > 0)
                return false;
            return this.inferOrgType(orgId) === 'enterprise';
        });
    }
    async _fetchEnterpriseContactsFromServer(missingIds, lokiApi, domain, _account) {
        if (!missingIds.length)
            return null;
        const orgInfoMap = await readOrgInfoByOrgIds(lokiApi, missingIds, _account);
        const groupsByEnterprise = new Map();
        missingIds.forEach(orgId => {
            const info = orgInfoMap.get(orgId);
            if (!info)
                return;
            const group = groupsByEnterprise.get(info.enterpriseId) || { qyIds: [], orgIds: [] };
            group.qyIds.push(info.originId);
            group.orgIds.push(orgId);
            groupsByEnterprise.set(info.enterpriseId, group);
        });
        const results = await Promise.all([...groupsByEnterprise.entries()].map(([enterpriseId, group]) => this.ctx.contactServer.enterpriseModule.fetchEnterpriseUnitContacts(group.qyIds, group.orgIds, domain, enterpriseId, _account)));
        const merged = { contacts: [], contactItems: [], orgContacts: [] };
        results.forEach(r => {
            if (!r)
                return;
            merged.contacts.push(...r.contacts);
            merged.contactItems.push(...r.contactItems);
            merged.orgContacts.push(...r.orgContacts);
        });
        return merged.contacts.length > 0 || merged.orgContacts.length > 0 ? merged : null;
    }
    _updateLokiMapFromServer(serverResult, missingIds, lokiOrgContactsMap) {
        if (!serverResult)
            return;
        serverResult.orgContacts.forEach(oc => {
            var _a;
            if (!missingIds.includes(oc.orgId))
                return;
            const existing = lokiOrgContactsMap.get(oc.orgId) || [];
            existing.push({
                id: oc.id,
                contactId: oc.contactId,
                orgId: oc.orgId,
                type: oc.type || 'enterprise',
                enterpriseId: oc.enterpriseId || -1,
                rankNum: (_a = oc.rankNum) !== null && _a !== void 0 ? _a : 0,
            });
            lokiOrgContactsMap.set(oc.orgId, existing);
        });
    }
    _scheduleCacheWrite(serverResult, missingIds, lokiApi, _account) {
        if (!serverResult || !missingIds.length)
            return;
        const orgIdsWithValidOrgContacts = missingIds.filter(orgId => serverResult.orgContacts.some(oc => oc.orgId === orgId));
        if (!orgIdsWithValidOrgContacts.length) {
            console.warn('[contact_impl] _scheduleCacheWrite: no valid orgContacts for requested orgIds, skip cache write');
            return;
        }
        const validContactIds = new Set(serverResult.orgContacts.map(oc => oc.contactId));
        const validContacts = serverResult.contacts.filter(c => validContactIds.has(c.id));
        const validContactItems = serverResult.contactItems.filter(ci => validContactIds.has(ci.contactId));
        const capturedOrgContacts = serverResult.orgContacts;
        Promise.resolve()
            .then(async () => {
            var _a;
            await Promise.all(orgIdsWithValidOrgContacts.map(orgId => deleteOrgContactsByOrgId(lokiApi, orgId, _account)));
            await Promise.all([writeOrgContactsToLoki(lokiApi, capturedOrgContacts, _account), writeContactsToLoki(lokiApi, validContacts, validContactItems, _account)]);
            await this.ctx.contactDB.enterpriseModule.writeOrgContactsOnDemandToDexie({
                orgIds: orgIdsWithValidOrgContacts,
                contacts: validContacts,
                contactItems: validContactItems,
                orgContacts: capturedOrgContacts,
                _account,
            });
            (_a = this.ctx.contactSync.tracker) === null || _a === void 0 ? void 0 : _a.recordIncrementalOp({
                api: 'getEnterpriseUnitContacts',
                timestamp: Date.now(),
                returnCount: validContacts.length,
                targetTables: ['contact', 'contactItem', 'orgContact'],
                dexieWritten: validContacts.length,
                lokiWritten: validContacts.length,
                params: `orgIds=[${missingIds.slice(0, 3).join(',')}${missingIds.length > 3 ? '...' : ''}]`,
            });
        })
            .catch(ex => {
            console.warn('[contact_impl] _scheduleCacheWrite fire-and-forget write failed', ex);
        });
    }
    async _assembleLokiModels(lokiHitOrgIds, lokiOrgContactsMap, _account) {
        const lokiContactModelMap = new Map();
        if (!lokiHitOrgIds.length)
            return lokiContactModelMap;
        const allContactIds = new Set();
        lokiHitOrgIds.forEach(orgId => {
            (lokiOrgContactsMap.get(orgId) || []).forEach(row => allContactIds.add(row.contactId));
        });
        try {
            const memoryModels = await this.ctx.contactDB.getContactsInMemoryMode({
                fields: [...allContactIds],
                type: 'contactId',
                _account,
            });
            this.assembleContactModelsFromMemory(memoryModels, _account).forEach(m => {
                if (m.contact.id)
                    lokiContactModelMap.set(m.contact.id, m);
            });
        }
        catch (e) {
            console.warn('[contact_impl] _assembleLokiModels error', e);
        }
        return lokiContactModelMap;
    }
    _assembleServerModels(serverResult) {
        const serverModelMap = new Map();
        if (!serverResult)
            return serverModelMap;
        const { contacts, contactItems } = serverResult;
        const contactIdMap = util.listToMap(contacts, 'id');
        const contactInfoIdMap = util.listToMapValueList(contactItems, 'contactId');
        this.ctx.contactTrans
            .transformContactModel({
            orderByIdList: contacts.map(c => c.id),
            contactIdMap,
            contactInfoIdMap,
        })
            .forEach(m => {
            if (m.contact.id)
                serverModelMap.set(m.contact.id, m);
        });
        return serverModelMap;
    }
    _buildEnterpriseResult(enterpriseOrgIds, lokiOrgContactsMap, lokiModelMap, serverModelMap, missingEnterpriseOrgIds) {
        const ret = {};
        enterpriseOrgIds.forEach(orgId => {
            ret[orgId] = [];
        });
        const mergedModelMap = new Map([...serverModelMap, ...lokiModelMap]);
        enterpriseOrgIds.forEach(orgId => {
            const rows = lokiOrgContactsMap.get(orgId);
            if (!rows || rows.length === 0) {
                if (missingEnterpriseOrgIds.includes(orgId) && serverModelMap.size > 0) {
                    ret[orgId] = [...serverModelMap.values()];
                    console.warn(`[contact_impl] org ${orgId}: unitInfos invalid, fallback to all serverContacts for display (not cached)`);
                }
                return;
            }
            const models = [];
            [...rows]
                .sort((a, b) => { var _a, _b; return ((_a = b.rankNum) !== null && _a !== void 0 ? _a : 0) - ((_b = a.rankNum) !== null && _b !== void 0 ? _b : 0); })
                .forEach(row => {
                const model = mergedModelMap.get(row.contactId);
                if (model)
                    models.push(model);
            });
            ret[orgId] = models;
        });
        return ret;
    }
    async doGetContactByOrgIds(orgIdList, _account = this.ctx.contactUtil.getCurrentAccount()) {
        var _a, _b;
        const ret = orgIdList.reduce((obj, orgId) => {
            obj[orgId] = [];
            return obj;
        }, {});
        if (!orgIdList.length)
            return ret;
        const personalOrgIds = [];
        const enterpriseOrgIds = [];
        orgIdList.forEach(orgId => {
            if (this._isPersonalOrgId(orgId)) {
                personalOrgIds.push(orgId);
            }
            else {
                enterpriseOrgIds.push(orgId);
            }
        });
        const personalResultMap = await this._resolvePersonalOrgIds(personalOrgIds, _account);
        personalResultMap.forEach((models, orgId) => {
            ret[orgId] = models;
        });
        if (!enterpriseOrgIds.length)
            return ret;
        const lokiApi = this.getLokiApi();
        let domain = ((_a = this.ctx.systemApi.getCurrentUser(_account)) === null || _a === void 0 ? void 0 : _a.domain) || '';
        try {
            const orgList = await this.ctx.contactDB.getOrgList({
                idList: enterpriseOrgIds.slice(0, 1),
                _account: _account || ((_b = this.ctx.systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id) || '',
            });
            const orgEnterpriseId = lodashGet(orgList, '[0].enterpriseId');
            if (typeof orgEnterpriseId === 'number' && orgEnterpriseId > 0) {
                domain = this.ctx.contactServer.resolveDomain(orgEnterpriseId, _account);
            }
        }
        catch (_c) {
        }
        const lokiOrgContactsMap = await this._readLokiOrgContacts(enterpriseOrgIds, lokiApi, _account);
        const missingEnterpriseOrgIds = this._classifyMissingEnterpriseOrgIds(enterpriseOrgIds, lokiOrgContactsMap);
        const serverResult = await this._fetchEnterpriseContactsFromServer(missingEnterpriseOrgIds, lokiApi, domain, _account);
        this._updateLokiMapFromServer(serverResult, missingEnterpriseOrgIds, lokiOrgContactsMap);
        const lokiHitOrgIds = enterpriseOrgIds.filter(orgId => {
            const rows = lokiOrgContactsMap.get(orgId);
            return rows && rows.length > 0 && !missingEnterpriseOrgIds.includes(orgId);
        });
        const lokiModelMap = await this._assembleLokiModels(lokiHitOrgIds, lokiOrgContactsMap, _account);
        const serverModelMap = this._assembleServerModels(serverResult);
        const enterpriseResult = this._buildEnterpriseResult(enterpriseOrgIds, lokiOrgContactsMap, lokiModelMap, serverModelMap, missingEnterpriseOrgIds);
        Object.assign(ret, enterpriseResult);
        this._scheduleCacheWrite(serverResult, missingEnterpriseOrgIds, lokiApi, _account);
        return ret;
    }
    async doGetContactByOrgId(params) {
        const { orgId = this.ctx.contactUtil.StaticNodeKey.PERSON_ALL, _account = this.ctx.contactUtil.getCurrentAccount() } = params;
        const isSpecialPersonalOrg = orgId === this.ctx.contactUtil.StaticNodeKey.PERSON_ALL || orgId === this.ctx.contactUtil.StaticNodeKey.PERSON_NO_GROUP;
        if (isSpecialPersonalOrg) {
            const memoryModels = await this.ctx.contactDB.getPersonalContactsFromMemory(orgId, _account);
            const models = this.assembleContactModelsFromMemory(memoryModels, _account);
            return lodashOrderBy(models, ['contact.contactLabel', 'contact.contactPYName', 'contact.contactName'], ['asc', 'asc', 'asc']);
        }
        const orgIds = Array.isArray(orgId) ? orgId : [orgId];
        try {
            const res = await this.doGetContactByOrgIds(orgIds, _account);
            const list = orgIds.reduce((acc, orgId) => acc.concat(res[orgId]), []);
            return list;
        }
        catch (e) {
            console.error('[contact_impl] doGetContactByOrgId error', e);
            return [];
        }
    }
    async getServerAndLocalContactByEmails(emails, _account) {
        const [enterpriseData, personalData] = await Promise.all([
            this.ctx.contactServer.doGetContactByEmails(emails, _account),
            this.ctx.contactDB.getPersonalContactByEmails(emails, _account),
        ]);
        return [...enterpriseData, ...personalData];
    }
    async doGetContactByItem(_condition) {
        try {
            const condition = Object.assign(Object.assign({}, _condition), { _account: _condition._account || this.ctx.contactUtil.getCurrentAccount() });
            const { isIM, value, showDisable, filterType, type } = condition;
            let contactModelList = [];
            if (type !== 'yunxin' && type !== 'EMAIL') {
                console.warn('[contact] doGetContactByItem unsupported type:', type);
                return [];
            }
            if (type === 'yunxin') {
                const accounts = util.singleToList(value);
                contactModelList = await this.ctx.contactServer.doGetContactByYunxin(accounts, condition._account);
            }
            else if (type === 'EMAIL') {
                const accounts = util.singleToList(value);
                const emailMap = await this.doGetContactByEmail({ emails: accounts, _account: condition._account });
                const allModels = [];
                Object.values(emailMap).forEach(list => allModels.push(...list));
                contactModelList = allModels;
            }
            const filterContactModelList = [];
            contactModelList.forEach(item => {
                const imFlag = !isIM || (isIM && item.contact.enableIM);
                const visibleFlag = !showDisable || (showDisable && item.contact.visibleCode === 0);
                const typeFlag = !filterType || (filterType && item.contact.type === filterType);
                if (imFlag && visibleFlag && typeFlag) {
                    filterContactModelList.push(util.addHitQuery({
                        data: item,
                        queryList: value,
                        hitList: [['contactInfo', 'contactItemVal']],
                    }));
                }
            });
            return filterContactModelList;
        }
        catch (e) {
            console.error('[contact] doGetContactByItem error:', e);
            return [];
        }
    }
    doGetVaildEmailByContact(pre, cur, isMainAccount) {
        return this.ctx.contactUtil.getValidEmail(pre, cur, isMainAccount);
    }
    async doGetContactByEmailsAdvance(params) {
        const { emails, _account, useData } = params;
        const startTime = Date.now();
        console.time('[contact_edm] doGetContactByEmailsAdvance');
        const data = await this.doGetContactByEmail({ emails, _account, useData });
        let listRes = [];
        emails.forEach(email => {
            const lxEmailData = data[email] || [];
            listRes = listRes.concat(lxEmailData);
        });
        console.timeEnd('[contact_impl] doGetContactByEmailsAdvance');
        const endTime = Date.now();
        if (endTime - startTime > 3 * 1000) {
            const iscontactready = await this.ctx.contactDB.detectCoreEnterpriseHasData({});
            this.ctx.dataTracker.track('pc_getcontactbyemail_performance', {
                _account: params._account,
                iscontactready,
                duration: endTime - startTime,
                count: emails && emails.length ? emails.length : 0,
                purecount: new Set(emails).size,
                reslen: listRes.length,
            });
            this.ctx.loggerApi.track('pc_getcontactbyemail_performance_detail', {
                params,
                listCount: listRes.length,
                mapResCount: Object.keys(data).length,
            });
        }
        console.log('[contact_impl] doGetContactByEmailsAdvance', params, { listRes, mapRes: data });
        return { listRes, mapRes: data };
    }
    async doGetContactByEmail({ emails, _account }) {
        const duplicateEmails = [...new Set(emails)].filter(Boolean);
        if (!duplicateEmails.length) {
            return {};
        }
        const account = _account || this.ctx.contactUtil.getCurrentAccount();
        let lokiResults = [];
        try {
            lokiResults = await this.ctx.contactDB.getContactsInMemoryMode({
                fields: duplicateEmails,
                type: 'email',
                _account: account,
            });
        }
        catch (e) {
            console.warn('[contact_impl] doGetContactByEmail loki query error', e);
        }
        const hitEmailSet = new Set();
        const lokiEmailMap = {};
        lokiResults.forEach(item => {
            const hitEmail = (item.hitQueryEmail || item.accountName || '').toLocaleLowerCase();
            hitEmailSet.add(hitEmail);
            const model = this.ctx.contactDB.transformMemoryModel2StandardModel(item);
            model._account = account;
            if (model.contact.type === 'personal') {
                const copy = cloneDeep(model);
                copy.contact.hitQueryEmail = hitEmail;
                (lokiEmailMap[hitEmail] = lokiEmailMap[hitEmail] || []).push(copy);
            }
            else {
                (lokiEmailMap[hitEmail] = lokiEmailMap[hitEmail] || []).push(model);
            }
        });
        const missedEmails = duplicateEmails.filter(e => !hitEmailSet.has(e.toLocaleLowerCase()));
        const personalOnlyEmails = duplicateEmails.filter(e => {
            const models = lokiEmailMap[e.toLocaleLowerCase()];
            return models && models.length > 0 && models.every(m => m.contact.type === 'personal');
        });
        const needServerEmails = [...new Set([...missedEmails, ...personalOnlyEmails])];
        let serverEmailMap = {};
        if (needServerEmails.length) {
            const serverModels = await this.fetchContactBase({
                queryType: 'email',
                queryValues: needServerEmails,
                _account: account,
            });
            const serverContactMap = new Map();
            const serverEmailIdMap = new Map();
            serverModels.forEach(m => {
                serverContactMap.set(m.contact.id, m);
                m.contactInfo.forEach(ci => {
                    if (ci.contactItemType !== 'EMAIL')
                        return;
                    const e = (ci.contactItemVal || '').toLocaleLowerCase();
                    const s = serverEmailIdMap.get(e) || new Set();
                    s.add(m.contact.id);
                    serverEmailIdMap.set(e, s);
                });
            });
            needServerEmails.forEach(email => {
                const e = email.toLocaleLowerCase();
                const list = [];
                (serverEmailIdMap.get(e) || new Set()).forEach(id => {
                    const m = serverContactMap.get(id);
                    if (!m)
                        return;
                    if (m.contact.type === 'personal') {
                        const copy = cloneDeep(m);
                        copy.contact.hitQueryEmail = e;
                        list.push(copy);
                    }
                    else {
                        list.push(m);
                    }
                });
                serverEmailMap[email] = list;
            });
        }
        const result = {};
        duplicateEmails.forEach(email => {
            const e = email.toLocaleLowerCase();
            result[email] = [...(lokiEmailMap[e] || []), ...(serverEmailMap[email] || [])];
        });
        return result;
    }
    async doGetContactByEmailFilter({ emails, _account }) {
        const emailMap = await this.doGetContactByEmail({ emails, _account });
        const res = {};
        const contactMap = {};
        const contactModelList = [];
        emails.forEach(email => {
            const models = emailMap[email] || [];
            models.forEach(item => {
                item.contactInfo.forEach(info => {
                    if (info.contactItemType === 'EMAIL') {
                        const infoEmail = info.contactItemVal.toLocaleLowerCase();
                        const model = contactMap[infoEmail];
                        if (model) {
                            contactMap[infoEmail] = this.ctx.contactUtil.getValidModel(model, item);
                        }
                        else {
                            contactMap[infoEmail] = item;
                        }
                    }
                });
            });
        });
        emails.forEach(email => {
            const model = contactMap[email.toLocaleLowerCase()] || contactMap[email];
            if (model) {
                res[email] = model;
                contactModelList.push(model);
            }
        });
        this.ctx.contactSelectNotify.addRecentSelectContactMap(contactModelList);
        return res;
    }
    async doGetContactByYunxin(accounts) {
        let needRequestAccounts = [];
        let contactModelList = [];
        const _account = this.ctx.contactUtil.getCurrentAccount();
        if (!accounts.length) {
            return { needRequestAccounts, contactModelList };
        }
        try {
            const lxInfoRows = await this.ctx.lokiApi.getByRangeCondition({
                dbName: contactSearchDbName,
                tableName: lxInfoTable,
                adCondition: {
                    type: 'anyOf',
                    field: 'yxid',
                    args: [accounts],
                },
                _dbAccount: _account,
            });
            const yxidToContactId = new Map();
            (lxInfoRows || []).forEach(row => {
                if (row.yxid && row.contactId) {
                    yxidToContactId.set(row.yxid, row.contactId);
                }
            });
            const contactIds = [...new Set(yxidToContactId.values())];
            if (contactIds.length) {
                const memoryModels = await this.ctx.contactDB.getContactsInMemoryMode({
                    fields: contactIds,
                    type: 'contactId',
                    _account,
                });
                const contactIdToYxid = new Map();
                yxidToContactId.forEach((cid, yxid) => contactIdToYxid.set(cid, yxid));
                contactModelList = this.assembleContactModelsFromMemory(memoryModels, _account, contactIdToYxid);
            }
            const matchedContactIds = new Set(contactModelList.map(m => m.contact.id));
            accounts.forEach(account => {
                const contactId = yxidToContactId.get(account);
                if (!contactId || !matchedContactIds.has(contactId)) {
                    needRequestAccounts.push(account);
                }
            });
            if (contactModelList.length) {
                contactModelList = util.addHitQueryList({
                    data: contactModelList,
                    queryList: accounts,
                    hitList: [['contactInfo', 'contactItemVal']],
                });
            }
        }
        catch (e) {
            console.error('[contact] doGetContactByYunxin error:', e);
            needRequestAccounts = accounts;
        }
        if (needRequestAccounts.length) {
            console.log('[contact] not found accounts', needRequestAccounts);
        }
        return { needRequestAccounts, contactModelList };
    }
    async doGetServerContactByYunxin(accounts) {
        return this.ctx.contactServer.doGetContactByYunxin(accounts);
    }
    async doGetServerContactByEmails(emails, _account, uniqueEmail) {
        if (!emails || !emails.length) {
            return [];
        }
        const account = _account || lodashGet(this.ctx.systemApi.getCurrentUser(), 'id', '');
        return this.ctx.contactServer.doGetContactByEmails(emails, account, uniqueEmail);
    }
    async doGetOrgContactListByIM(_params) {
        console.warn('[contact] doGetOrgContactListByIM is deprecated');
        return [];
    }
    async doGetOrgContactListByTeamId(params) {
        var _a, _b;
        const { idList, orderBy, needGroup, needContactData, needContactModelData, filterSelf = true } = params;
        if (!(idList === null || idList === void 0 ? void 0 : idList.length)) {
            return [];
        }
        const _account = this.ctx.contactUtil.getCurrentAccount();
        const orgContactsMap = await readOrgContactsByOrgIds(this.ctx.lokiApi, idList, _account);
        const allContactIds = new Set();
        orgContactsMap.forEach(rows => {
            rows.forEach(row => allContactIds.add(row.contactId));
        });
        if (!allContactIds.size) {
            return [];
        }
        let contactModelMap;
        let contactEntityMap;
        if (needContactData || needContactModelData) {
            const contactIds = [...allContactIds].filter(Boolean);
            const contactModels = await this.doGetContactById(contactIds, _account);
            if (needContactModelData) {
                contactModelMap = new Map();
                contactModels.forEach(m => {
                    if (m.contact.id)
                        contactModelMap.set(m.contact.id, m);
                });
            }
            else {
                contactEntityMap = new Map();
                contactModels.forEach(m => {
                    if (m.contact.id)
                        contactEntityMap.set(m.contact.id, m.contact);
                });
            }
        }
        let selfContactId;
        if (filterSelf) {
            const user = this.ctx.systemApi.getCurrentUser();
            selfContactId = (_b = (_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.id;
        }
        let list = [];
        for (const orgId of idList) {
            const rows = orgContactsMap.get(orgId) || [];
            for (const row of rows) {
                if (selfContactId && row.contactId === selfContactId)
                    continue;
                const item = {
                    id: row.id,
                    contactId: row.contactId,
                    orgId: row.orgId,
                    enterpriseId: row.enterpriseId,
                    rankNum: row.rankNum,
                    yunxinId: row.yunxinId || '',
                    imId: row.imId || '',
                    type: row.type || '',
                    nickInTeam: row.nickInTeam || '',
                    joinTime: row.joinTime || 0,
                    _lastUpdateTime: row._lastUpdateTime || 0,
                };
                if (contactModelMap) {
                    item.model = contactModelMap.get(row.contactId);
                }
                else if (contactEntityMap) {
                    item.contact = contactEntityMap.get(row.contactId);
                }
                list.push(item);
            }
        }
        const effectiveOrderBy = orderBy || ['joinTime'];
        list = this.ctx.contactDB.setDataOrder({ data: list, orderBy: effectiveOrderBy });
        if (needGroup && idList.length) {
            return idList.map(orgId => list.filter(item => item.orgId === orgId));
        }
        return list;
    }
    async doUpdateContactById(contact) {
        var _a, _b;
        const originContactList = util.singleToList(contact);
        const { success, data } = await this.ctx.contactDB.updateContactById({
            list: originContactList,
            _account: ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '',
        });
        if (success && data) {
            const { personalIdList, enterpriseIdList } = data;
            this.ctx.contactDB.sendContactNotify({
                contact_personal: { updateDiff: [...personalIdList] },
                contact_enterprise: { updateDiff: [...enterpriseIdList] },
                syncStatus: {
                    enterprise: !!enterpriseIdList.length,
                    personal: !!personalIdList.length,
                },
                _account: ((_b = this.ctx.systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id) || '',
            });
            return true;
        }
        return false;
    }
    async doUpdateContactModel(list) {
        var _a, _b;
        const { success, data } = await this.ctx.contactDB.updateContactModel({
            list,
            _account: ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '',
        });
        if (success && data) {
            const { personalIdList, enterpriseIdList } = data;
            this.ctx.contactDB.sendContactNotify({
                contact_personal: { updateDiff: [...personalIdList] },
                contact_enterprise: { updateDiff: [...enterpriseIdList] },
                syncStatus: {
                    enterprise: !!enterpriseIdList.length,
                    personal: !!personalIdList.length,
                },
                _account: ((_b = this.ctx.systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id) || '',
            });
            return true;
        }
        return false;
    }
    doInsertOrReplacePersonal(params) {
        var _a;
        const _account = params._account || ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        return this.ctx.contactDB.doInsertOrReplacePersonal(Object.assign(Object.assign({}, params), { _account }));
    }
    async doGetAllContactList(_account) {
        console.warn('[contact] doGetAllContactList is deprecated');
        return [];
    }
    async doGetAllOrgContact(_account) {
        console.warn('[contact] doGetAllOrgContact is deprecated');
        return [];
    }
    async doGetColleagueByOrgIds(params) {
        const res = await this.ctx.contactCollegeHelper.getContactIdByUnitId(params);
        let contactIdSet = new Set();
        Object.values(res).forEach(item => {
            contactIdSet = new Set([...contactIdSet, ...item]);
        });
        const contactIdList = [...contactIdSet];
        if (!contactIdList.length) {
            return {};
        }
        const modelList = await this.doGetContactById(contactIdList);
        const modelMap = {};
        modelList.forEach(item => {
            const { id } = item.contact;
            if (id) {
                modelMap[id] = item;
            }
        });
        const ret = {};
        Object.keys(res).forEach(orgId => {
            ret[orgId] = res[orgId].map(contactId => modelMap[contactId]);
        });
        return ret;
    }
    async doGetColleagueList() {
        return this.ctx.contactServer.getColleagueList();
    }
    async doGetResignList() {
        return this.ctx.contactServer.getResignList();
    }
    doGetColleagueFolderList(id, emails) {
        return this.ctx.contactServer.getColleagueFolderList(id, emails);
    }
    async doGetColleaguePromotion() {
        var _a, _b, _c, _d;
        let res = false;
        try {
            const url = this.ctx.systemApi.getUrl('getPromotionSetting');
            const urlOrder = this.ctx.systemApi.getUrl('getPromotionOrderSetting');
            const resArr = await Promise.all([this.ctx.http.post(url), this.ctx.http.get(urlOrder)]);
            const data = (_a = resArr[0]) === null || _a === void 0 ? void 0 : _a.data;
            const dataOrder = (_b = resArr[1]) === null || _b === void 0 ? void 0 : _b.data;
            let res1 = false;
            let res2 = false;
            if (Number(data === null || data === void 0 ? void 0 : data.code) === 200 && Array.isArray((_c = data === null || data === void 0 ? void 0 : data.result) === null || _c === void 0 ? void 0 : _c.data) && ((_d = data === null || data === void 0 ? void 0 : data.result) === null || _d === void 0 ? void 0 : _d.data.length) > 0) {
                const dataRes = data.result.data.find((item) => item.func === 'colleague_list');
                if (dataRes && !!dataRes.adminHit && !!dataRes.orgHit) {
                    res1 = true;
                }
            }
            if (Number(dataOrder === null || dataOrder === void 0 ? void 0 : dataOrder.code) === 200 && !!(dataOrder === null || dataOrder === void 0 ? void 0 : dataOrder.data)) {
                res2 = true;
            }
            if (res1 && res2) {
                res = true;
            }
        }
        catch (error) {
            console.log('获取下属推广设置失败', error);
        }
        return res;
    }
    async doUpdateColleaguePromotion() {
        var _a, _b, _c;
        let res = false;
        try {
            const url = this.ctx.systemApi.getUrl('updatePromotionSetting');
            const dataRes = await this.ctx.http.post(url, { func: 'colleague_list', off: true });
            if (Number((_a = dataRes.data) === null || _a === void 0 ? void 0 : _a.code) === 200 && !!((_c = (_b = dataRes.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.suc)) {
                res = true;
            }
        }
        catch (error) {
            console.log('关闭下属推广', error);
        }
        return res;
    }
}
